import * as Yup from 'yup';

const feedbackFormValidationSchema = Yup.object().shape({
  reason: Yup.string().required(),
  comment: Yup.string().min(10).required(),
});

export default feedbackFormValidationSchema;
